<template>
  <div class="usage-table-body">
    <!-- todo: use vs table -->
    <table class="table">
      <thead>
        <tr>
          <th v-for="(col, i) in tableColumns" :key="i" :class="[col.class, { active: col.name === activeUsage }]">
            {{ col.label | t }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(usageRow, i) in pagedUsageData" :key="i">
          <td v-for="(col, y) in tableColumns" :key="y" :class="[col.class, { active: col.name === activeUsage }]">
            {{ displayFormat(usageRow[col.colname], col.type, col.format) }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pager">
      <div class="pager-buttons">
        <button class="button is-small" :disabled="currentPage === 0" @click="pageDown">
          <i class="icon-angle-left" aria-hidden="true" />
        </button>
        <button class="button is-small" :disabled="currentPage >= lastPageNumber" @click="pageUp">
          <i class="icon-angle-right" aria-hidden="true" />
        </button>
      </div>
      <div class="paper-per-number">
        {{ currentPageAndMaxLength }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeUsage: {
      type: String,
      required: true,
    },
    validUsageData: {
      type: Array,
      required: true,
    },
    tableColumns: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      perPage: 10, // todo: make to change by select box,
      currentPage: 0,
    };
  },
  computed: {
    lastPageNumber() {
      return Math.floor(this.validUsageData.length / this.perPage);
    },
    isLoading() {
      for (let usageKey in this.usageData) {
        if (this.usageData[usageKey].isLoading) {
          return true;
        }
      }
      return false;
    },
    pagedUsageData() {
      const startIndex = this.currentPage * this.perPage;
      return this.validUsageData.slice(startIndex, startIndex + this.perPage);
    },
    currentPageAndMaxLength() {
      // return this.validUsageData.length
      const lastCountOfPage =
        (this.currentPage + 1) * this.perPage <= this.validUsageData.length
          ? (this.currentPage + 1) * this.perPage
          : this.validUsageData.length;
      return `${this.currentPage * this.perPage + 1} - ${lastCountOfPage} of ${this.validUsageData.length}`;
    },
  },
  watch: {
    validUsageData() {
      this.currentPage = 0;
    },
  },
  methods: {
    displayFormat(value, type, format) {
      if (type === "date") {
        return `${value.substr(0, 4)}/${value.substr(4, 2)}/${value.substr(6, 2)}`;
      }
      return this.$options.filters.numberFormat(value, format);
    },
    pageUp() {
      this.currentPage++;
    },
    pageDown() {
      this.currentPage--;
    },
  },
};
</script>

<style scoped lang="scss">
.usage-table-body {
  .table {
    width: 100%;
    margin-bottom: 0 !important;
    border: solid 1px $gray-300;
    border-collapse: collapse;

    th,
    td {
      border: solid 1px $gray-300;
    }

    th {
      height: 65px;
      font-size: 10px;
      vertical-align: middle;

      &.value {
        width: 11%;
      }
    }

    tbody {
      td {
        width: 10%;
        height: 40px;
        font-size: 10px;
        text-align: right;
        vertical-align: middle;
      }

      td.ts {
        text-align: left;
      }
    }

    td.active {
      background-color: #d7f3f1;
    }
  }

  .pager {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    height: 68px;
    border: solid 1px $gray-300;
    border-top: 0;
    background-color: white;

    .pager-buttons {
      margin: 0 20px;

      .button {
        margin-right: 2px;
        border: 0;
      }
    }
  }
}

.usage-table-footer {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  height: 68px;
  background-color: white;
}
</style>
